<template>
    <div class="mainPage">
        <div class="header_banner">
            <!-- <img src="../img/cio/m_cio_banner.png" alt="" class="bg"> -->
            <div class="header">
                <div class="titleCon">
                    <div class="menuYear" @click="showMemu = !showMemu">
                        {{ currentMenu }}
                        <span class="caret" :class="{ 'activeCaret': showMemu }"></span>
                        <div class="menuList" :class="{ 'menuActive': showMemu }">
                            <span :class="{ 'active': currentMenu == 2023 }" @click="changePage(2023)">2023</span>
                            <span :class="{ 'active': currentMenu == 2022 }"
                                @click="changePage(2022, 'https://z.chineseplus.net/dist/#/pcpage/chineseplus_live2022')">2022</span>
                            <span :class="{ 'active': currentMenu == 2021 }"
                                @click="changePage(2021, 'https://z.chineseplus.net/dist/#/pcpage/chineseplus_classlive')">2021</span>
                            <span :class="{ 'active': currentMenu == 2020 }"
                                @click="changePage(2020, 'https://z.chineseplus.net/cio_classlive.html')">2020</span>
                        </div>
                    </div>
                    <div class="languageCon">
                        <language></language>
                    </div>
                    <div class="memuCon">
                        <img src="../img/chinesebridge/menu.png" alt="" @click="toggleMenu()">
                        <div class="menu" v-show="activeMenu">
                            <div class="menuUserName" v-if="isLogin">{{ user.username }}</div>
                            <div class="logOut" v-if="isLogin" @click="toLogOut()">退出</div>
                            <div class="menuUserName" v-if="!isLogin" @click="toLogin()">登录</div>
                            <div class="logOut" v-if="!isLogin" @click="toLogin()">注册</div>
                        </div>
                    </div>
                </div>
                <div class="content">

                    <div class="centerBg">
                        <img src="../img/2023chinesepluslive/m_title.png" alt="" class="left" v-if="language == 'cn'">
                        <img src="../img/2023chinesepluslive/m_title.png" alt="" class="left" v-if="language == 'en'">
                        <img src="../img/2023chinesepluslive/m_title.png" alt="" class="left" v-if="language == 'es'">
                        <img src="../img/2023chinesepluslive/m_title.png" alt="" class="left" v-if="language == 'fr'">
                        <img src="../img/2023chinesepluslive/m_title.png" alt="" class="left" v-if="language == 'ru'">
                    </div>
                </div>
                <!-- <div>
                  <img src="../img/2022chinesepluslive/bg_right.png" alt="" class="right_bg">
                </div> -->
            </div>
        </div>
        <div class="tabCon">
            <div class="menuYear" @click="showTabCon = !showTabCon">
                <span class="title" v-if="activeTab == 0">{{ $t('message.allCourse') }}</span>
                <span class="title" v-if="activeTab == 3">{{ $t('message.HSK4B') }}</span>
                <span class="title" v-if="activeTab == 1">{{ $t('message.HSK4A') }}</span>
                <span class="title" v-if="activeTab == 2">{{ $t('message.spokenChinese2') }}</span>
                <span class="caret" :class="{ 'activeCaret': showTabCon }"></span>
                <div class="menuList" :class="{ 'menuActive2': showTabCon }" v-if="language == 'ru'">
                    <span :class="{ 'activeTab': activeTab == 0 }" @click="changeTab(0)">{{ $t('message.allCourse')}}</span>
                    <span :class="{ 'activeTab': activeTab == 3 }" @click="changeTab(3)">{{ $t('message.HSK4B') }}</span>
                    <span :class="{ 'activeTab': activeTab == 1 }" @click="changeTab(1)">{{ $t('message.HSK4A') }}</span>
                    <span :class="{ 'activeTab': activeTab == 2 }" @click="changeTab(2)">{{ $t('message.spokenChinese2')}}</span>
                </div>
                <div class="menuList" :class="{ 'menuActive': showTabCon }" v-else>
                    <span :class="{ 'activeTab': activeTab == 0 }" @click="changeTab(0)">{{ $t('message.allCourse')}}</span>
                    <span :class="{ 'activeTab': activeTab == 3 }" @click="changeTab(3)">{{ $t('message.HSK4B') }}</span>
                    <span :class="{ 'activeTab': activeTab == 1 }" @click="changeTab(1)">{{ $t('message.HSK4A') }}</span>
                    <span :class="{ 'activeTab': activeTab == 2 }" @click="changeTab(2)">{{ $t('message.spokenChinese2')}}</span>
                </div>
            </div>

            <!-- <div>
                <div class="tabBtn" :class="{ 'activeTab': activeTab == 0 }" @click="changeTab(0)">
                    <div>{{ $t('message.allCourse') }}</div>
                </div>
                <div class="tabBtn" :class="{ 'activeTab': activeTab == 1 }" @click="changeTab(1)">
                    <div>{{ $t('message.HSK4') }} </div>
                </div>
                <div class="tabBtn" :class="{ 'activeTab': activeTab == 2 }" @click="changeTab(2)">
                    <div>{{ $t('message.spokenChinese2') }} </div>
                </div>

            </div> -->
        </div>
        <div class="courseListCon">
            <ul class="list">
                <li v-for="(item, index) in courseList" :key="item.id"
                    :class="{ 'live': item.customStatus == 1, 'finished': item.customStatus == 2 }"
                    v-show="activeTab == 0 || (item.category == activeTab && activeTab != 0)">
                    <div class="timeCon">
                        <span class="time">{{ new Date(+item.start_time).Format('YYYY.MM.DD hh:mm') }}-{{ new
                            Date(+item.end_time).Format('hh:mm') }}</span>

                        <span v-if=" language == 'cn' || language == 'en'">
                            <span class="status live" v-if="item.customStatus == 0">
                                {{ $t('message.classnNoBegin') }}
                            </span>
                            <span class="status live" v-if="item.customStatus == 1">
                                {{ $t('message.classLive') }}
                            </span>
                            <span class="status finished" v-if="item.customStatus == 2">
                                {{ $t('message.classFinished') }}
                            </span>
                        </span>
                        <span v-else-if="language == 'es' || language == 'fr' || language == 'ru'">
                            <span class="status live live2" v-if="item.customStatus == 0">
                                {{ $t('message.classnNoBegin') }}
                            </span>
                            <span class="status live live2" v-if="item.customStatus == 1">
                                {{ $t('message.classLive ') }}
                            </span>
                            <span class="status finished finished2 " v-if="item.customStatus == 2">
                                {{ $t('message.classFinished') }}
                            </span>
                        </span>

                    </div>
                    <div class="detailBox">
                        <div class="nameCon">
                            <div class="name" v-if="language == 'cn'">
                                <span>
                                    {{ item.name }}
                                </span>
                            </div>
                            <div class="name name_en" v-if="language == 'en'">
                                <span v-if="item.name_en">
                                    {{ item.name_en }}
                                </span>
                                <span v-else>
                                    {{ item.name }}
                                </span>
                            </div>
                            <div class="name name_en" v-if="language == 'es'">
                                <span v-if="item.name_es">
                                    {{ item.name_es }}
                                </span>
                                <span v-else>
                                    {{ item.name }}
                                </span>
                            </div>
                            <div class="name name_en" v-if="language == 'fr'">
                                <span v-if="item.name_fr">
                                    {{ item.name_fr }}
                                </span>
                                <span v-else>
                                    {{ item.name }}
                                </span>
                            </div>
                            <div class="name name_en" v-if="language == 'ru'">
                                <span v-if="item.name_ru">
                                    {{ item.name_ru }}
                                </span>
                                <span v-else>
                                    {{ item.name }}
                                </span>
                            </div>
                        </div>
                        <div class="titleCon">
                            <div class="title">
                                <div class="cn" v-if="language == 'cn'">
                                    {{ item.teacher_name }}
                                </div>
                                <div class="en" v-if="language == 'en'">
                                    <span v-if="item.teacher_name_en">
                                        {{ item.teacher_name_en }}
                                    </span>
                                    <span v-else>
                                        {{ item.teacher_name }}
                                    </span>
                                </div>
                                <div class="en" v-if="language == 'es'">
                                    <span v-if="item.teacher_name_es">
                                        {{ item.teacher_name_es }}
                                    </span>
                                    <span v-else>
                                        {{ item.teacher_name }}
                                    </span>
                                </div>
                                <div class="en" v-if="language == 'fr'">
                                    <span v-if="item.teacher_name_fr">
                                        {{ item.teacher_name_fr }}
                                    </span>
                                    <span v-else>
                                        {{ item.teacher_name }}
                                    </span>
                                </div>
                                <div class="en" v-if="language == 'ru'">
                                    <span v-if="item.teacher_name_ru">
                                        {{ item.teacher_name_ru }}
                                    </span>
                                    <span v-else>
                                        {{ item.teacher_name }}
                                    </span>
                                </div>
                            </div>
                            <div class="liveBtn">
                                <span class="join"
                                    v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false"
                                    @click="join(item, index, false)">
                                    <span class="En">
                                        {{ $t('message.join') }}
                                    </span>
                                </span>
                                <span class="join replay" v-if="item.status == 3" @click="replay(item.video_url)">
                                    <span class="En">
                                        {{ $t('message.playBack') }}
                                    </span>
                                </span>
                                <span class="isOrder"
                                    v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == true">
                                    {{ $t('message.classnNoBegin') }}
                                </span>
                                <span class="join" v-if="item.status == 1 && item.customStatus == 1"
                                    @click="joinToLive(item, index)">
                                    <span class="En">
                                        {{ $t('message.enter') }}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>

                </li>
                <div class="nomore" >{{ $t('message.noMore') }}</div>
            </ul>
        </div>
        <!-- <div class="guideModel" v-if="isShowGuide">
            <div class="close" @click="isShowGuide = false">×</div>
            <a href="https://z.chineseplus.net/dist/#/m_page/m_guide" target="_blank"><img src="../img/cio/chineseplus_guide.png" alt=""></a>
        </div> -->
        <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                    <div class="closeVideo" @click="closeVideo()">×</div>
                    <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls
                            controlsList="nodownload"></video></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'
import language from './common/language'
export default {
    name: 'chinesebridge',
    components: {
        language
    },
    metaInfo() {
        return {
            title: '中文联盟在线直播教学-我要学习汉语_汉语文化线上培训平台',
            meta: [
                {
                    name: 'keyword',
                    content: '中文联盟在线直播教学,汉语文化线上培训平台,我要学习汉语'
                },
                {
                    name: 'description',
                    content: '中文联盟汉语文化线上培训平台开设在线直播教学,利用碎片化时间,加强汉语言学习,我要学习汉语就来中文联盟!'
                },
            ]
        }
    },
    data: function () {
        return {
            languageIndex: 0,
            languageList: [
                {
                    name: "cn",
                    val: "中文"
                },
                {
                    name: "en",
                    val: "English"
                },
                {
                    name: "es",
                    val: "Español"
                },
                {
                    name: "fr",
                    val: "Français"
                },
                {
                    name: "ru",
                    val: "Русский"
                }
            ],
            showMemu: false,
            showTabCon: false, //课程下拉列表
            currentTabCon: '全部课程111',
            currentMenu: 2023,
            activeMenu: false,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
            user: {
                username: '',
                email: ''
            },
            isShowGuide: true,
            subject_info: {},
            courseList: [],
            activeTab: 3,
            subject_id: null,
            beforeTime: 30, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间
        }
    },
    computed: {
        language() {
            return this.$i18n.locale
        }
    },
    methods: {
        changePage(page, url) {
            // this.currentMenu = page
            if (url) {
                window.open(url);
            }
        },
        changeTab(tab) {
            this.activeTab = tab;
            if (tab == 0) {
                this.currentTabCon = "1111111111";
            } else if (tab == 1) {
                this.currentTabCon = "333333333333333";
            } else if (tab == 2) {
                this.currentTabCon = "werrfsdf";
            }
        },
        tolive(url) {
            window.open(url)
        },
        toLogin() {
            window.location.href =
                this.baseUrl +
                "user/api/login?" +
                "callback=" +
                encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if (res.data.success) {
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
                // this.getCourseInfo(this.subject_id)
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if (res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(alias) {
            this.$utils.get('/subject/subject/readbyalias', {
                alias
            }).then(res => {
                if (res.data.success) {
                    this.subject_info = res.data.data
                    this.getCourseInfo(this.subject_info.id)
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlist', {
                subject_id: id,
                limit: 200
            }).then(res => {
                if (res.data.success) {
                    var now = new Date().getTime()
                    var endTime = now - this.afterTime * 60 * 1000;
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                    res.data.data.list.forEach(e => {
                        e.isOrder = false
                        e.customStatus = 0
                        if (nowBeforeFiveMin > e.start_time) {
                            e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                        }
                        if (endTime > e.end_time) {
                            e.customStatus = 2
                        }
                    })
                    this.courseList = res.data.data.list
                    this.categoryName()
                    console.log(this.courseList)
                    this.checkOrdeList()
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        categoryName() {
            this.courseList.forEach(e => {
                if (e.name.indexOf('HSK标准会话教程（4上）') > -1) {
                    e.category = 1
                } else if (e.name.indexOf('《汉语口语速成》提高篇') > -1) {
                    e.category = 2
                } else if (e.name.indexOf('HSK标准会话教程（4下）') > -1) {
                    e.category = 3
                }
            })
        },
        // 检查可预约直播间
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms' + "?time=" + new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) {
                            this.courseList[index].isOrder = true
                            this.$set(this.courseList, index, this.courseList[index])
                        }
                    })
                }
            })
        },
        join(item, index, islive) {
            if (!this.isLogin) {
                this.toLogin()
                return
            }
            const data = Qs.stringify({
                room_id: item.room_id,
                user: this.user.email,
                secret: "03198325b8b61ccc3413cf7e754febea",
                key: "zyz",
                username: this.user.username,
                realname: this.user.username
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user' + "?time=" + new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList[index].isOrder = true
                    this.$set(this.courseList, index, this.courseList[index])
                    if (islive) {
                        window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
                    }
                }
            })
        },
        joinToLive(item, index) {
            if (!this.isLogin) {
                this.toLogin()
                return
            }
            if (!item.isOrder) {
                this.join(item, index, true)
            } else {
                window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            }
        },
        replay(url) {
            this.isPlay = true
            this.currentVideoUrl = url
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (!myvideo.paused) {
                myvideo.pause();
            }
            this.isPlay = false
        },
        toggleMenu() {
            this.activeMenu = !this.activeMenu
        }
    },
    mounted() {
        // this.subject_id = this.$route.query.id
        // this.subject_id = 116 // 停课不停学固定id：116
        this.customCheckLogin()
        this.getSubjectInfo('chineseplus_2023live')
        let activeTab = this.$route.query.tab
        if (activeTab) {
            this.activeTab = activeTab
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    min-height: 100%;
    overflow-x: hidden;

    .header_banner {
        width: 100%;
        height: 5.2rem;
        //     background-image: linear-gradient(0deg, 
        // #ffffff 0%, 
        // #cad9ff 100%), 
        //     linear-gradient(
        //         #6187d6, 
        //         #6187d6);
        //     background-blend-mode: normal, 
        // normal;
        background-image: url(../img/2023chinesepluslive/m_bg.png);
        background-size: cover;
        position: relative;
        overflow: hidden;

        .bg {
            width: 100%;
            height: 4.93rem;
        }

        .header {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            z-index: 1;
            text-align: left;

            .titleCon {
                line-height: 0.4rem;
            }

            .title {
                font-size: 0.38rem;
                color: #fff;
                margin-left: 0.48rem;
            }

            .menuYear {
                position: absolute;
                left: 0.2rem;
                top: 0.18rem;
                font-size: 0.3rem;
                z-index: 5;
                padding: 0.04rem 0.08rem 0.04rem 0.08rem;
                border-radius: 0.1rem;
                color: #6173bf;
                // font-weight: bold;
                background-color: #fff;
                cursor: pointer;

                .caret {
                    display: inline-block;
                    width: 0;
                    height: 0;
                    margin-bottom: 3px;
                    margin-left: 3px;
                    vertical-align: middle;
                    border-top: 6px dashed;
                    border-top: 6px solid\9;
                    border-right: 6px solid transparent;
                    border-left: 6px solid transparent;
                    opacity: .9;
                }

                .activeCaret {
                    border-top: none;
                    border-bottom: 6px dashed;
                }

                .menuList {
                    position: absolute;
                    width: 100%;
                    top: 0.56rem;
                    font-size: 0.3rem;
                    left: 0;
                    color: #282828;
                    font-weight: normal;
                    background-color: #fff;
                    border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
                    box-shadow: 0 0.02rem 0.12rem 0 rgba(0, 0, 0, 0.2);
                    transition: all linear 0.2s;
                    height: 0;
                    overflow: hidden;

                    span {
                        display: block;
                        padding: 0.1rem 0.08rem 0.1rem 0.08rem;
                        border-bottom: 1px solid #ccc;
                    }

                    .active {
                        color: #6173bf;
                    }
                }

                .menuActive {
                    height: 2.45rem;
                }
            }

            .languageCon {
                position: absolute;
                right: 0.8rem;
                top: 0.21rem;
                font-size: 0;
                z-index: 5;
            }

            .memuCon {
                position: absolute;
                right: 0.33rem;
                top: 0.21rem;
                font-size: 0;
                z-index: 5;

                img {
                    width: 0.4rem;
                }

                .menu {
                    position: absolute;
                    right: 0;
                    top: 0.55rem;
                    background-color: #fff;
                    width: 100px;
                    border-radius: 0.05rem;
                    padding: 0.1rem 0;
                    font-size: 0.3rem;

                    div {
                        color: #333;
                        text-align: center;
                        line-height: 200%;
                    }
                }
            }

            .right_bg {
                position: absolute;
                right: 0.2rem;
                top: 0;
                bottom: 0;
                margin: auto;
                width: 65%;
                opacity: 0.2;
            }

            .content {
                width: 100%;
                height: 100%;
                position: relative;

                .left {
                    display: inline-block;
                    width: 72%;
                    position: absolute;
                    z-index: 1;
                    top: 54%;
                    left: 14%;
                    transform: translateY(-50%);

                    .camp {
                        width: 64%;
                    }

                    .schoolInfo {
                        .logo {
                            height: 0.83rem;
                            margin-top: 0.23rem;
                        }

                        .name {
                            width: 100%;
                            padding: 0 0.68rem 0 0.5rem;
                            font-size: 0.8rem;
                            line-height: 1.2;
                            box-sizing: border-box;
                            text-align: left;
                            color: #fff;
                            font-weight: bold;
                            margin-top: 0.1rem;
                        }

                        .name_1 {
                            font-size: 0.46rem;
                            font-weight: normal;
                        }

                        .name_en {
                            width: 100%;
                            font-size: 0.46rem;
                            padding: 0 0.5rem;
                            box-sizing: border-box;
                            text-align: left;
                            font-family: "DINCond-Medium";
                            color: #fff;
                            margin-top: 0.26rem;
                        }
                    }
                }

            }
        }
    }

    .tabCon {
        width: 100%;
        position: relative;
        // overflow-x: auto;
        // overflow-y: hidden;
        height: 0.9rem;
        line-height: 0.9rem;
        background-color: #fff;
        // padding: 0 0.4rem;
        box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.1);
        white-space: nowrap;

        .menuYear {
            width: 100%;
            position: absolute;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 0.37rem;
            z-index: 5;
            // padding: 0.04rem 0.08rem 0.04rem 0.08rem;
            border-radius: 0.1rem;
            color: #6173bf;
            // font-weight: 600;
            font-weight: bold;
            background-color: #fff;
            margin-left: 0.3rem;
            cursor: pointer;

            .title {
                overflow: hidden;
                text-overflow: ellipsis; //文本超出块元素时以省略号的形式显示
                white-space: nowrap; //规定段落中的文本不进行换行
                width: 90%;
                text-align: left;
            }

            .caret {
                display: inline-block;
                width: 10%;
                height: 0.5rem;
                background-image: url(../img/2023chinesepluslive/m_tabIcon.png);
                background-size: cover;
                background-repeat: no-repeat;
                margin-right: 0.5rem;
            }

            .activeCaret {
                width: 0.5rem;
                height: 0.5rem;
                background-image: url(../img/2023chinesepluslive/m_tabIcon2.png);
            }

            .menuList {
                position: absolute;
                width: 100%;
                top: 0.92rem;
                font-size: 0.3rem;
                left: 0;
                color: #282828;
                font-weight: normal;
                background-color: #fff;
                border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
                box-shadow: 0 0.02rem 0.12rem 0 rgba(0, 0, 0, 0.2);
                transition: all linear 0.2s;
                height: 0;
                margin-left: -0.3rem;
                text-align: left;
                overflow: hidden;
                word-wrap: break-word;
                word-break: normal;
                white-space: normal;

                span {
                    display: block;
                    line-height: normal;
                    padding: 0.3rem;
                    border-bottom: 1px solid #ccc;
                }

                .active {
                    color: #6173bf;
                }
            }

            .menuActive {
                height: 4.05rem;
            }
            .menuActive2 {
                height: auto;
            }
        }

        >div {
            // width: 1200px;
            margin: auto;
        }

        .tabBtn {
            display: inline-block;
            margin-right: 0.25rem;
            font-size: 0.4rem;
            cursor: pointer;
            text-align: left;
            vertical-align: top;

            div:last-child {
                font-size: 0.32rem;
                font-family: "DIN-Regular";
            }
        }

        .tabBtn_1 {
            div:last-child {
                font-size: 0.22rem;
                font-family: "DIN-Regular";
                margin-left: 0.1rem;
            }
        }

        .activeTab {
            position: relative;
            color: #6173bf;

            :after {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                display: inline-block;
                content: '';
                width: 70%;
                height: 0.1rem;
                background-color: #6173bf;
            }
        }

    }

    .courseListCon {
        margin: auto;
        background-color: #fff;

        .liveClass {
            padding-top: 0.25rem;
            width: 100%;
            text-align: center;

            img {
                width: 2.78rem;
            }
        }

        .list {
            position: relative;
            padding: 0 0.14rem;
            text-align: left;
            margin-top: 0.67rem;

            // &:before {
            //     position: absolute;
            //     left: 0.16rem;
            //     width: 0.08rem;
            //     height: calc(100% + 1rem);
            //     content: '';
            //     background-color: #fd9c29;
            // }
            li {
                margin-left: 0.55rem;
                margin-bottom: 1.1rem;
                position: relative;

                &:before {
                    position: absolute;
                    left: -0.68rem;
                    top: -0.16rem;
                    content: '';
                    width: 0.6rem;
                    height: 3.7rem;
                    background-image: url(../img/2023chinesepluslive/m_icon2.png);
                    background-size: cover;
                    background-repeat: no-repeat;
                }

                .timeCon {
                    font-size: 0;

                    .time {
                        font-size: 0.3rem;
                        color: #5e696d;
                        font-family: "DIN-Medium";
                        vertical-align: top;
                    }

                    .live {
                        font-size: 0.21rem;
                        color: #ffffff;
                        background-color: #3caf4f;
                        margin-left: 30px;
                        vertical-align: text-top;
                        padding: 5px 9px 5px 6px;
                        border-radius: 10px 0 10px 0;
                        vertical-align: middle;
                        font-family: "Georgia";
                    }

                    .live2 {
                        display: inline-block;
                        white-space: nowrap;
                        margin-left: 0.1rem;
                        margin-top: 0.2rem;
                    }

                    .finished {
                        font-size: 0.21rem;
                        color: #ffffff;
                        background-color: #93a4aa;
                        margin-left: 30px;
                        vertical-align: text-top;
                        padding: 5px 9px 5px 6px;
                        border-radius: 10px 0 10px 0;
                        vertical-align: middle;
                        font-family: "Georgia";
                    }

                    .finished2 {
                        display: inline-block;
                        white-space: nowrap;
                        margin-left: 0.1rem;
                        margin-top: 0.2rem;
                    }
                }

                .detailBox {
                    width: 93%;
                    // height: 2.8rem;
                    margin-top: 0.2rem;
                    border: 1px solid #d6d6d6;
                    border-radius: 10px;
                    box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.1);

                    .nameCon {
                        margin-top: 0.26rem;
                        margin-bottom: 0.3rem;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                        font-size: 0.28rem;

                        .name {
                            font-size: 0.34rem;
                            line-height: 1.2;
                            color: #364347;
                        }

                        .name_en {
                            font-size: 0.28rem;
                            line-height: 1.2;
                            color: #5e696d;
                            margin-bottom: 8px;
                            font-family: 'Georgia';
                        }
                    }

                    .titleCon {
                        font-size: 0.25rem;
                        height: 1.6rem;
                        width: 100%;
                        margin-left: 0.2rem;

                        .title {
                            color: #8da6ac;
                            display: inline-block;
                            width: calc(100% - 2.5rem);

                            .en {
                                font-size: 0.25rem;
                                font-family: 'Georgia';
                                margin-bottom: 0.02rem;
                                width: 100%;
                                line-height: 1.2;
                            }

                            .cn {
                                font-size: 0.25rem;
                                width: 100%;
                                line-height: 1.2;
                            }
                        }

                        .liveBtn {
                            // float: right;
                            // display: inline-block;
                            font-family: 'Georgia';
                            color: #282828;
                            margin-top: 0.3rem;

                            .join {
                                position: relative;
                                display: inline-block;
                                height: 0.5rem;
                                // width: 2rem;
                                line-height: 1.2;
                                border-radius: 25px;
                                background-color: #fff;
                                color: #fa6c51;
                                border: 1px solid #fa6c51;
                                // padding: 15px 31px;
                                box-sizing: border-box;
                                cursor: pointer;

                                &:before {
                                    position: absolute;
                                    content: '';
                                    left: 0.24rem;
                                    top: 0.14rem;
                                    border-top: 0.1rem solid transparent;
                                    border-bottom: 0.1rem solid transparent;
                                    border-left: 10px solid #fa6c51;
                                }

                                .En {
                                    line-height: 0.5rem;
                                    margin-left: 0.5rem;
                                    margin-right: 0.4rem;
                                    vertical-align: top;
                                }

                                .Cn {
                                    font-size: 0.24rem;
                                    vertical-align: top;
                                }
                            }

                            .replay {
                                color: #8da6ac;
                                border: 1px solid #8da6ac;

                                &:before {
                                    position: absolute;
                                    content: '';
                                    left: 0.24rem;
                                    top: 0.14rem;
                                    border-top: 0.1rem solid transparent;
                                    border-bottom: 0.1rem solid transparent;
                                    border-left: 0.15rem solid #8da6ac;
                                }

                                .En {
                                    line-height: 0.5rem;
                                    margin-left: 0.5rem;
                                    margin-right: 0.4rem;
                                    vertical-align: top;
                                }

                                .Cn {
                                    font-size: 0.24rem;
                                    vertical-align: top;
                                }
                            }

                            .isOrder {
                                color: #999;
                                font-size: 0.24rem;
                            }
                        }
                    }
                }


            }

            .live:before {
                background-image: url(../img/2023chinesepluslive/m_icon2.png);
            }

            .finished:before {
                background-image: url(../img/2023chinesepluslive/m_icon1.png);
            }

            .nomore {
                position: absolute;
                font-size: 0.3rem;
                bottom: -0.8rem;
                left: 0.7rem;
                color: #8da6ac;

            }

            .noMore {
                font-size: 0.25rem;
                margin-left: 0.4rem;
                color: #7ecef4;
                position: relative;
            }

            .noMore:after {
                position: absolute;
                right: 0;
                z-index: 1;
                top: 0.18rem;
                display: inline-block;
                content: '';
                height: 0.03rem;
                width: calc(100% - 2.8rem);
                background-color: #7ecef4;
            }
        }
    }

    .guideModel {
        position: fixed;
        right: 0;
        bottom: 40px;
        z-index: 5;
        cursor: pointer;

        .close {
            font-size: 28px;
            position: absolute;
            top: 15px;
            right: 15px;
            color: #fff;
            cursor: pointer;
        }
    }

    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
    }

    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }

    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .videoContainer {
        text-align: center;
        width: 100%;
    }

    .videoContainer video {
        width: 100%;
    }
}</style>
